<p>
  reload works!
</p>
